import React from 'react';
import PropTypes from 'prop-types';
import ProjectDetail from '../../common/ProjectDetail';

const renderDraftStatus = (requiredFieldsCount) => {
  if (requiredFieldsCount > 0) {
    return (
      <div>
        {`Complete ${requiredFieldsCount} required field${requiredFieldsCount !== 1 ? 's' : ''} to submit your project post!`}
        <i className="fa fa-running ms-2" />
      </div>
    );
  }
  return (
    <div>Submit your project to Clora for review</div>
  );
};

const renderOpenStatus = (state, candidatesNeedReview, projectType, invitationCount, proposalRequestConsultant) => {
  let status = 'Hired';
  let icon = 'handshake';
  let label = null;
  if (state === 'employer_requested_matching') {
    if (projectType === 'open_marketplace') {
      status = 'Invitations';
      icon = 'search';
      label = 'Connect and receive proposals';
    } else if (projectType === 'request') {
      status = 'Requested: Hire Again';
      icon = 'hourglass';
      label = `Waiting for ${proposalRequestConsultant}’s answer`;
    } else {
      status = 'Under review';
      icon = 'hourglass';
    }
  } else if (state === 'clora_matching' && candidatesNeedReview) {
    status = 'Review candidates';
    icon = 'users';
  } else if (state === 'clora_matching') {
    status = 'Vetting candidates';
    icon = 'filter';
  } else if (state === 'work_started') {
    status = 'Work started';
    icon = 'microscope';
  }
  return (
    <div className={`body-text-3 demibold g-row--always open-status ${label ? 'requires_more_attention' : ''}`}>
      <div className="circle-icon-container">
        <div className="g-column g-column--centered"><i className={`fa fa-${icon}`} /></div>
      </div>
      <div className={`g-column ${state} ${candidatesNeedReview ? 'candidates-needs-review' : ''}`}>
        <div>
          {invitationCount && projectType === 'open_marketplace' ? `(${invitationCount}) ${status}` : status}
          {label
            ? <div className="body-text-3 normal-weight">{label}</div>
            : (
              <div className="g-row--always tracking-bars">
                <div className="bar bar-1" />
                <div className="bar bar-2" />
                <div className="bar bar-3" />
                <div className="bar bar-4" />
                <div className="bar bar-5" />
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

const renderClosedStatus = (state) => {
  let status = 'Work completed';
  let icon = 'clipboard-check';
  if (state === 'on_hold') {
    status = 'On hold';
    icon = 'pause';
  } else if (state === 'closed') {
    status = 'Closed';
    icon = 'times';
  }
  return (
    <div className={`body-text-3 demibold g-row--always closed-status ${state}`}>
      <div className="circle-icon-container">
        <div className="g-column g-column--centered"><i className={`fa fa-${icon}`} /></div>
      </div>
      <div className="g-column g-column--centered">{status}</div>
    </div>
  );
};

function EmployerProjectCard(props) {
  const { project, status, showProjectEmploymentType } = props;
  let ctaText = 'View Project';
  let ctaLink = project.project_link;

  if (project.draft) {
    ctaText = 'Finish Draft';
    ctaLink = project.edit_project_link;
  } else if (project.proposals_need_attention) {
    ctaText = `View Proposal${project.proposals_count > 1 ? 's' : ''}`;
  } else if (project.reviewable) {
    ctaText = `Review ${project.accepted_consultant_initials}`;
    ctaLink = project.review_link;
  }

  return (
    <div className={`card box-shadow-1 project-${project.resource_id} mb-3 border-0`}>
      <ProjectDetail
        key={`project-${project.resource_id}`}
        className={status}
        name={project.name}
        workCommitment={project.lowest_time_per_week}
        tags={project.tags}
        duration={project.duration_range}
        workLocation={project.work_location}
        employmentType={project.employment_type}
        showProjectEmploymentType={showProjectEmploymentType}
      />

      <div className="cta-container mt-4 g-row-justify-right g-row">
        <div className={`pe-3 g-row--always cta ${status}`}>
          {status === 'open'
            && renderOpenStatus(
              project.status,
              project.proposals_need_attention,
              project.project_type,
              project.project_invitations,
              project.proposal_request_consultant,
            )}
          {status === 'closed' && renderClosedStatus(project.status)}
          <div className="body-text-2 medium-weight g-column g-column--centered cta-alert">
            {status === 'draft' && renderDraftStatus(project.required_fields_count)}
            {project.proposals_need_attention
              && `${project.proposals_count} proposal${project.proposals_count !== 1 ? 's' : ''}`}
          </div>
        </div>

        {project.reviewable
          && (
          <a href={`projects/${project.resource_id}`} data-status={project.status} className="employer-project-show btn btn-secondary-no-border">
            View Project
          </a>
          )}
        <a href={ctaLink} data-status={project.status} className={`${project.reviewable ? 'project-dashboard-review-consultant-btn' : 'employer-project-show'} btn btn-${project.expired ? 'default' : 'primary'}`}>
          {ctaText}
        </a>
      </div>
    </div>
  );
}

EmployerProjectCard.propTypes = {
  project: PropTypes.shape({}).isRequired,
  status: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool,
};

EmployerProjectCard.defaultProps = {
  showProjectEmploymentType: false,
};

export default EmployerProjectCard;
